<template>
  <div id="app">
		<div class="wrapper">
			<div id="nav">
				<a href="http://www.autoboxam.rs"></a>
				<input ref="input" type="text" v-model="query" @keyup="filter" placeholder="Pretraži komponente...">
				<span class="search"></span>
				<div id="mode">
					<p>Stroga pretraga</p>
					<label class="switch">
	  				<input type="checkbox" @click="strictToggle">
	  				<span class="slider round"></span>
					</label>
				</div>
			</div>
		</div>
		<app-table :data="filteredData" :query="query"></app-table>
		<footer>
			<div class="wrapper_footer">
				<span>Poslednji put ažurirano 14.04.2018.</span>
				<span>All rights reserved © 2018 - Autobox AM</span>
			</div>

		</footer>
  </div>
</template>

<script>
	import kitData from './kit_data.json';
	import Table from './Table.vue';
  export default {
    data() {
      return {
				kitData: kitData,
				query: '',
				strictMode: false,
				filteredData: kitData
			}
    },
		methods: {
			filter() {
				this.filteredData = [];

				for(var kit of this.kitData) {
					for(var item of kit) {
						var kit = kit;

						if(this.strictMode) {

							if(typeof this.spliter(item) === "string") {

								if(item === this.query) {
									this.filteredData.push(kit);
									break;
								}
							} else {
								var parts = this.spliter(item);

								if(parts[0] === this.query) {
									this.filteredData.push(kit);
								} else if (parts[1] === this.query) {
									this.filteredData.push(kit);
								}
							}

						} else {
							if(item.includes(this.query)) {
								this.filteredData.push(kit);
								break;
							}
						}
					}
				}
				this.filteredData = this.removeDuplicates(this.filteredData);
				if(this.query == '') {
					this.filteredData = this.kitData;
				}
			},
			spliter(c) {
				var splited = c.split(" | ");
  			if(splited.length === 1) {
    			return c;
  			} else {
    			return splited;
  			}
			},
			strictToggle() {
				this.strictMode = !this.strictMode;
				this.query = ''
				// console.log(this.strictMode);
			},
			removeDuplicates(arr) {
				return arr.filter(function(elem, pos, arr) {
    			return arr.indexOf(elem) == pos;
  			});
			}
		},
		mounted() {
			this.$refs.input.focus();
		},
		components: {
			'app-table': Table
		}
  }
</script>

<style scoped>
.wrapper {
	width: 100%;
	height: 54px;
	background-color: #262626;
	border-top: 3px solid #EA263D;
	position: fixed;
	top: 0;
	// box-shadow: 0 2px 5px rgba(0,0,0,0.19), 0 4px 4px rgba(0,0,0,0.23);
}
#nav {
	width: 1060px;
	height: 100%;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	position: relative;
}

#nav a {
	background-image: url('./assets/logov2.png');
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
	line-height: 54px;
	width: 160px;
	height: 100%;
	display: block;
	padding-left: 10px;
}

#nav input {
	padding: 0px 12px;
	margin-top: 7px;
	height: 20px;
	width: 500px;
	border: 0;
	height: 40px;
	outline: none;
	border-radius: 3px;
	// background-color: #f1eded;
	position: relative;
}

.search {
	position: absolute;
	width: 24px;
	height: 24px;
	background-image: url('./assets/search_icon.png');
	background-size: contain;
	background-repeat: no-repeat;
	right: 270px;
	top: 16px;
	pointer-events: none;
	opacity: 0.4;
}

.switch {
  position: relative;
  display: block;
  width: 46px;
  height: 24px;
	margin-top: 12px;
}

/* Hide default HTML checkbox */
.switch input {display:none;}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #676767;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 4px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}


input:checked + .slider {
  background-color: #EA263D;
}

input:checked + .slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

#mode {
	display: flex;
	font-family: 'Lato', sans-serif;
	color: #e8e8e8;
	font-size: 14px;
	justify-content: space-between;
	width: 150px;
	margin-top: 3px;
	//margin-left: 100px;
}

footer {
	position: fixed;
	height: 30px;
	width: 100%;
	z-index: 100;
	background-color: #262626;
	bottom: 0;

}

.wrapper_footer {
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: rgb(119, 119, 119);
	font-family: 'Lato', sans-serif;
	font-size: 14px;
	height: 100%;
	max-width: 1080px;
	margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue